import { AppThunk } from '../reducers';
import * as ActionTypeValues from './types/SideDrawerActionTypes';
import type { SetSideDrawerActionType, SideDrawerContent } from './types/SideDrawerActionTypes';

const setSideDrawer = (content: SideDrawerContent | null): SetSideDrawerActionType => ({
  type: ActionTypeValues.SET_SIDE_DRAWER,
  payload: content,
});

export function closeSideDrawer(): AppThunk<void> {
  return (dispatch) => {
    dispatch(setSideDrawer(null));
  };
}

export function openSideDrawer(content: SideDrawerContent): AppThunk<void> {
  return (dispatch) => {
    dispatch(setSideDrawer(content));
  };
}
